<template>
  <div>
    <el-card :body-style="{ padding: '0px' }">
      <h3 class="title">基本信息</h3>
      <el-form label-position="left" ref="ruleForm" :model="basicData" :disabled="disabledFlag">
        <el-form-item label-width="120px" prop="categoryId">
          <el-row slot="label">
            <span class="name">产品</span>
            <!-- <el-tooltip content="所选品类为已注册产品品类" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip> -->
          </el-row> 
          <el-col :span="12">
            <el-input v-if="selStatus == 'view' || selStatus == 'edit'" v-model="basicData.productName" disabled />
            <el-select v-else v-model="basicData.productKey" filterable
              placeholder="请选择产品品类" style="width: 100%;">
              <el-option v-for="item in products" :key="item.productKey" :label="item.productName+'  ('+item.productKey+')'" :value="item.productKey" />
            </el-select>   
            
          </el-col>  
        </el-form-item>
        <!-- <el-form-item v-if="basicData.categoryId" label-width="120px" prop="productBrand">
          <el-row slot="label">
            <span class="name">品牌</span>
            <el-tooltip content="根据所选品类选择对应品牌" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
          <el-col :span="12">
            <el-select @change="brandSel" :disabled="selStatus !== 'add'" v-model="basicData.productBrand"
              placeholder="请选择品牌" style="width: 100%;">
              <el-option v-for="item in brand" :key="item.id" :label="item.commonName" :value="item.id" />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="modelFlag" label-width="120px" prop="productModel">
          <el-row slot="label">
            <span class="name">型号</span>
            <el-tooltip content="根据所选品类与品牌选择对应型号" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
          <el-col :span="12">
            <el-select v-model="basicData.productModel" placeholder="请选择产品品类" style="width: 100%;">
              <el-option v-for="item in productType" :key="item.id" :label="item.commonName" :value="item.id" />
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label-width="120px" prop="productPic">
          <el-row slot="label">
            <span class="name">产品图片</span>
            <el-tooltip content="产品主图" placement="top" effect="light">
              <span class="el-icon-question" style="margin-left: 10px"></span>
            </el-tooltip>
          </el-row>
          <el-col :span="12">
            <UploadPic @getData="getData" :picData="basicData" />
            <el-image v-if="basicData.productUrl !== ''" style="width: 100px; height: 100px" :src="basicData.productUrl"
              :preview-src-list="[basicData.productUrl]"></el-image>
          </el-col>
        </el-form-item> -->
      </el-form>
    </el-card>
  </div>
</template>
<script>
import UploadPic from '@/components/categoryManager/uploadPic'
import { brandList, subCategoryList, modelList, getFilterProduct } from '@/api/appGuide'
export default {
  components: {
    UploadPic
  },
  props: {
    basicData: {
      type: Object
    },
    disabledFlag: {
      type: Boolean
    },
    selStatus: {
      type: String
    },
    allImgList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    modelFlag() {
      if (this.basicData.categoryId && this.basicData.productBrand) {
        this.getModelId()
        return true
      } else {
        return false
      }
    }
  },
  data() {
    const picVerify = (rule, value, callback) => {
      if (!this.basicData.productPic) {
        callback(new Error('请选择图片'))
      } else {
        callback()
      }
    }
    return {
      form: {},
      // rules: {
      //   categoryId: [
      //     { required: true, message: '请选择产品品类', trigger: 'blur' }
      //   ],
      //   productBrand: [
      //     { required: true, message: '请选择产品品牌', trigger: 'blur' }
      //   ],
      //   productModel: [
      //     { required: true, message: '请选择产品型号', trigger: 'blur' }
      //   ],
      //   productPic: [
      //     { required: true, validator: picVerify, trigger: 'change' }
      //   ]
      // },
      products: [],
      category: [], // 品类
      brand: [], // 品牌
      productType: [] // 型号
    }
  },
  watch: {
    'basicData.categoryId': {
      immediate: true,
      handler(val) {
        if (val) this.getBrandList()
      }
    }
  },
  created() {
    // this.getCategoryList()
    this.getFilterProductHandle();
  },
  methods: { 
    getFilterProductHandle() {
      getFilterProduct({
        params: {}
      }).then(res => {
        this.products = res.data.data;
      })
    },
    brandSel(val) {
      console.log(val)
      this.basicData.productModel = ''
    },
    categorySel(val) {
      this.basicData.productModel = ''
      this.basicData.productBrand = ''
    },
    // 获取品牌信息
    getBrandList() {
      const params = this.basicData.categoryId
      brandList({ params }).then((res) => {
        const result = res.data.data
        this.brand = result
      })
    },
    // 获取品类信息
    getCategoryList() {
      const params = {
        flag: '1'
      }
      subCategoryList({ params }).then((res) => {
        const result = res.data.data
        this.category = result
      })
    },
    // 获取型号
    getModelId() {
      // this.basicData.productModel = ''
      const params = {
        categoryId: this.basicData.categoryId,
        productBrand: this.basicData.productBrand
      }
      modelList({ params }).then((res) => {
        const result = res.data.data
        this.productType = result
      })
    },
    getData(val) {
      console.log(val.fileUrl)
      this.basicData.productPic = val.fileKey
      this.basicData.productUrl = val.fileUrl
      this.allImgList.push(val.fileKey)
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-form-item__label {
  display: flex;
  align-items: center !important;
}

.el-card {
  padding: 14px;
}

.title {
  width: 10%;
  padding: 5px 5px 5px 0;
  display: inline-block;
  margin-bottom: 10px;
  border-bottom: 1px solid #777777;
}

.el-col-12 {
  flex-direction: column;
}

.el-image {
  margin-top: 20px;
}
</style>
